// extracted by mini-css-extract-plugin
export default {"Rating":"styles_Rating__6yT4b","Review":"styles_Review__1eIOg","Quotes":"styles_Quotes__SCKJn","Person":"styles_Person__Vp7EX","Footer":"styles_Footer__niG4-"};